import React from 'react';
import { Form, Icon, Message, Divider } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

//utils
import queries from '../../../../src/utils/queries'

const ListaTC = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipo" id="miLista1" value={permiteUpdate?argsDocum.tipo:idLista.tipo} onChange={(ev)=>handleChange(ev)}>
        <option>Comercial</option>
        <option>Técnico</option>
        <option>Laboratorio</option>
        <option>Administrativo</option>
        <option>Externo</option>
      </select>
    </div>
  )
}; 
const ListaEst = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="estado" id="miLista2" value={permiteUpdate?argsDocum.estado?argsDocum.estado:"Activo":idLista.estado?idLista.estado:"Activo"} onChange={(ev)=>handleChange(ev)}>
        <option>Activo</option>
        <option>Inactivo</option>
      </select>
    </div>
  )
};
const ListaHalla = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="gestionaHallazgos" id="miLista3" value={permiteUpdate?argsDocum.gestionaHallazgos?argsDocum.gestionaHallazgos:"No":idLista.gestionaHallazgos?idLista.gestionaHallazgos:"No"} onChange={(ev)=>handleChange(ev)}>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};
// const ListaVM = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="versionMacro" id="miLista2" value={permiteUpdate?argsDocum.versionMacro:idLista.versionMacro} onChange={(ev)=>handleChange(ev)}>
//         <option>1</option>
//         <option>2</option>
//       </select>
//     </div>
//   )
// };
const ListaLider = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="esLider" id="miLista4" value={permiteUpdate?argsDocum.esLider?argsDocum.esLider:"No":idLista.esLider?idLista.esLider:"No"} onChange={(ev)=>handleChange(ev)}>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};
const DetalleNivel1 = props => {
  return (
    <option value={props.elemento._id}>{props.elemento.descrPerfil}</option>
  )
}; 

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="perfil" id="miLista" value={permiteUpdate?argsDocum.idPerfil:idLista.perfil._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

//Empresa
const DetalleNivel1C = props => {
  return (
    <option>{props.elemento.descrEmpresa}</option>
  )
};

const ListaC = ({listC, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = listC.map((elemento, _id) => <DetalleNivel1C elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miListaE" value={permiteUpdate?argsDocum.descrEmpresa:idLista.descrEmpresa} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN Empresa

const DetalleNivel1U = props => {
  return (
    <option>{props.elemento.nombreUsuario}</option>
  )
};

const ListaU = ({listU, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = listU.map((elemento, _id) => <DetalleNivel1U elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="suLider" id="miListaU" value={permiteUpdate?argsDocum.suLider:idLista.suLider} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerUsu2 extends React.Component {
  state={
    argsDocum: {email: this.props.idLista.email,
                nombreUsuario: this.props.idLista.nombreUsuario,
                idPerfil: this.props.idLista.perfil._id,
                descrPerfil: this.props.idLista.perfil.descrPerfil,
                _id: this.props.idLista._id,
                descrEmpresa: this.props.idLista.descrEmpresa,
                versionMacro: 1,
                tipo: this.props.idLista.tipo?this.props.idLista.tipo:'',
                cedula: this.props.idLista.cedula?this.props.idLista.cedula:'',
                ciudad: this.props.idLista.ciudad?this.props.idLista.ciudad:'',
                cargo: this.props.idLista.cargo?this.props.idLista.cargo:'',
                telefono: this.props.idLista.telefono?this.props.idLista.telefono:'',
                archivoFirma: this.props.idLista.archivoFirma?this.props.idLista.archivoFirma:"",
                estado: this.props.idLista.estado?this.props.idLista.estado:'Activo',
                gestionaHallazgos: this.props.idLista.gestionaHallazgos?this.props.idLista.gestionaHallazgos:'No',
                esLider: this.props.idLista.esLider?this.props.idLista.esLider:'No',
                suLider: this.props.idLista.suLider?this.props.idLista.suLider:''},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      if(ev.target.name !== "email"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "perfil"){
          var miLista = document.getElementById("miLista");
          argsDocum['descrPerfil'] = miLista.options[miLista.selectedIndex].text
          argsDocum['idPerfil'] = miLista.options[miLista.selectedIndex].value
        }else{
          if(ev.target.name==='file'){
            let file = ev.target.files[0]
            let archivoFirma = ev.target.files[0].name
            argsDocum['archivoFirma'] = archivoFirma
            argsDocum['file'] = file
          }else{
            if(ev.target.name === "descrEmpresa"){
              var miLista = document.getElementById("miListaE");
              argsDocum['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
            }else{  
              // if(ev.target.name === "versionMacro"){
              //   var miLista = document.getElementById("miLista2");
              //   argsDocum['versionMacro'] = miLista.options[miLista.selectedIndex].text
              // }else{
                if(ev.target.name === "tipo"){
                  var miLista = document.getElementById("miLista1");
                  argsDocum['tipo'] = miLista.options[miLista.selectedIndex].text
                }else{
                  if(ev.target.name === "estado"){
                    var miLista = document.getElementById("miLista2");
                    argsDocum['estado'] = miLista.options[miLista.selectedIndex].text
                  }else{
                    if(ev.target.name === "gestionaHallazgos"){
                      var miLista = document.getElementById("miLista3");
                      argsDocum['gestionaHallazgos'] = miLista.options[miLista.selectedIndex].text
                    }else{
                      if(ev.target.name === "esLider"){
                        var miLista = document.getElementById("miLista4");
                        argsDocum['esLider'] = miLista.options[miLista.selectedIndex].text
                      }else{
                        if(ev.target.name === "suLider"){
                          var miLista = document.getElementById("miListaU");
                          argsDocum['suLider'] = miLista.options[miLista.selectedIndex].text
                        }else{
                          argsDocum[ev.target.name] = ev.target.value
                        }
                      }
                    } 
                  } 
                }           
            }
          }
        }
        //console.log(argsDocum)
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    console.log(this.props.idLista)
console.log(argsDocum)
    let listaCPer = []
    if(this.props.data.allPerfiles){listaCPer = this.props.data.allPerfiles}
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let nombreUsuarioAnt = this.props.idLista.nombreUsuario
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large user plus yellow icon"></i>
          Usuario
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, nombreUsuarioAnt):()=>{}}>
            <div className="ui three column stackable grid">
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Tipo de usuario</label>
                      <ListaTC styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Correo electrónico</label>
                      <input autoComplete="off" name="email" id="email" value={this.state.argsDocum.email} onChange={this.handleChange} placeholder='Correo electrónico' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Nombre del usuario</label>
                      <input autoComplete="off" name="nombreUsuario" id="nombreUsuario" value={this.props.permiteUpdate?this.state.argsDocum.nombreUsuario:this.props.idLista.nombreUsuario} onChange={this.handleChange} placeholder='Nombre del usuario' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreUsuario'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Cédula</label>
                      <input autoComplete="off" name="cedula" id="cedula" value={this.props.permiteUpdate?this.state.argsDocum.cedula:this.props.idLista.cedula} onChange={this.handleChange} placeholder='Cédula' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'cedula'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>    
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Perfil</label>
                      <Lista list={listaCPer} handleLista={this.props.handleLista} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>                                
                  <Form.Field>
                    <label style={this.props.styles.label}>Cargo</label>
                    <input autoComplete="off" name="cargo" id="cargo" value={this.props.permiteUpdate?this.state.argsDocum.cargo:this.props.idLista.cargo} onChange={this.handleChange} placeholder='Cargo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'cargo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Ciudad</label>
                      <input autoComplete="off" name="ciudad" id="ciudad" value={this.props.permiteUpdate?this.state.argsDocum.ciudad:this.props.idLista.ciudad} onChange={this.handleChange} placeholder='Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'ciudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Teléfono</label>
                      <input autoComplete="off" name="telefono" id="telefono" value={this.props.permiteUpdate?this.state.argsDocum.telefono:this.props.idLista.telefono} onChange={this.handleChange} placeholder='Teléfono' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>     
                    <Form.Field>
                      <label style={this.props.styles.label}>Solo de la empresa</label>
                      <ListaC listC={this.props.list1} handleLista={this.props.handleLista} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Estado del usuario</label>
                      <ListaEst styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Gestiona hallazgos</label>
                      <ListaHalla styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen de firma...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>
                </div>
                {/* <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Versión de macro</label>
                      <ListaVM styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div> */}
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Es lider ?</label>
                      <ListaLider styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>     
                    <Form.Field>
                      <label style={this.props.styles.label}>Su lider es:</label>
                      <ListaU listU={this.props.list2} handleLista={this.props.handleLista} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
              </div>
              <Divider inverted />

              <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
              
              {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }
          </Form>
        </div>
      </div>
    )
  }
}

export default graphql(queries.query.allPerfiles)(VerUsu2)
